/**
 * 🟦 V11.5 — Export Recipe.
 *
 * Genera un JSON portable (sin appId ni datos sensibles) y dispara la
 * descarga client-side como `{name}.dxa-recipe.json`. NO toca el iframe
 * ni el recipesStore.
 */

const RECIPE_VERSION = '1.0';

/**
 * Genera el payload portable a partir de una receta local.
 * No incluye appId. Acota nombre/desc a longitudes razonables.
 */
export function buildPortableRecipe(recipe) {
  if (!recipe || typeof recipe !== 'object') return null;
  if (!recipe.name || !Array.isArray(recipe.steps) || recipe.steps.length === 0) return null;
  const cleanSteps = recipe.steps
    .map((s) => ({
      instruction: String(s?.instruction || '').slice(0, 240),
      patch: Array.isArray(s?.patch) ? s.patch.filter((op) => op && typeof op.op === 'string' && typeof op.path === 'string') : [],
    }))
    .filter((s) => s.patch.length > 0);
  if (cleanSteps.length === 0) return null;
  return {
    version: RECIPE_VERSION,
    id: String(recipe.id || ''),
    name: String(recipe.name).slice(0, 80),
    description: String(recipe.description || '').slice(0, 240),
    nodeType: String(recipe.nodeType || 'div').toLowerCase(),
    steps: cleanSteps,
    createdAt: recipe.createdAt || new Date().toISOString(),
  };
}

function slugify(name) {
  return String(name || 'recipe')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)+/g, '')
    .slice(0, 60) || 'recipe';
}

/**
 * Descarga la receta como archivo .dxa-recipe.json. Devuelve el payload
 * generado para que el caller pueda mostrar el toast.
 */
export function downloadRecipe(recipe) {
  const portable = buildPortableRecipe(recipe);
  if (!portable) return null;
  const blob = new Blob([JSON.stringify(portable, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${slugify(portable.name)}.dxa-recipe.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return portable;
}
